import { render } from "./SuccessOk.vue?vue&type=template&id=40a7ea2e&scoped=true"
import script from "./SuccessOk.vue?vue&type=script&lang=js"
export * from "./SuccessOk.vue?vue&type=script&lang=js"

import "./SuccessOk.vue?vue&type=style&index=0&id=40a7ea2e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a7ea2e"]])

export default __exports__